import store from '@/store';

export const SOCKET_ACTIONS = {
  RUN_VIDEO: 'run_video',
  RUN_CHANNEL: 'run_channel',
  RUN_SOURCE: 'run_source',
  OPEN_SOURCE_APP: 'open_source_app',
  OPEN_APP: 'open_app',
  SET_LANGUAGE: 'set_language',
  SET_TV_PACKAGE: 'set_tvpackage',
  TURN_OFF: 'turn_off',
  TURN_ON: 'turn_on',
  SOCKET_ONOPEN: 'send_message',
  OPEN_WELCOME_SCREEN: 'open_welcome_screen',
  OPEN_HOME: 'open_home',
  // Eine Seite der App gezielt oeffnen - Info und App-Installation kamen
  // bisher nur ueber die Farbtasten-Folge am Geraet.
  OPEN_PAGE: 'open_page',
  REBOOT: 'reboot',
  UPDATE: 'update',
  SHOW_MESSAGE: 'show_message',
  OPEN_WEBSITE: 'open_website',
  GET_INFO: 'get_info',
  // Die App-Listen des Geraets. Eigene Anfrage, weil der Katalog eines
  // Hospitality-TV dreistellig viele Eintraege hat und die Zustandsdaten in
  // get_info sonst untergehen.
  GET_APPS: 'get_apps',
  // Die geraeteinternen Einstellungen (Service-/Pro:Centric-Menue). Lesen und
  // Setzen sind getrennt, weil die Antwort auf get_settings die Werte TRAEGT
  // und damit ihr eigener Ack ist - wie bei get_info.
  GET_SETTINGS: 'get_settings',
  SET_SETTINGS: 'set_settings',
  // Die Uhr des Geraets setzen - Nutzlast { time: {year, month, day, hour,
  // minute, second} } als Wanduhrzeit. Die Antwort traegt die Uhr vorher und
  // nachher und ist ihr eigener Ack (siehe helpers/DeviceClock).
  SET_TIME: 'set_time',
  // Nur die Uhr lesen - leicht genug, um sie im Admin wiederholt abzufragen,
  // ohne jedes Mal die ganze Infoseite samt Cast-Erkennung zu bauen.
  GET_TIME: 'get_time',
  // Cast / OTT (Samsung Tizen primaer)
  OPEN_CAST: 'open_cast',
  CAST_PREPARE: 'cast_prepare',
  FIRMWARE_UPDATE: 'firmware_update',
  CLONE_UPDATE: 'clone_update',
  // Die Gegenrichtung zu clone_update: ein Clonefile vom USB-Stick des Geraets
  // einsammeln. Nur Samsung - siehe helpers/CloneUpload.
  UPLOAD_CLONE: 'upload_clone',
  // Was im Clone-Ordner des Sticks liegt - Baum mit Pfad und Groesse. Damit
  // laesst sich eine einzelne Datei gezielt holen (upload_clone mit `path`),
  // etwa die was/clone.xml mit der App-Liste.
  LIST_CLONE: 'list_clone',
  // Speicher und Dateien ansehen. Eigenes Kommando, weil es Dateien anfasst -
  // in get_info hat das einen U800F zum Neustart gebracht.
  GET_FILES: 'get_files',
  CLEAR_CREDENTIALS: 'clear_credentials',
  // Nur LG: den Checkout-Snapshot nehmen - den Zustand, auf den clear_credentials
  // den TV spaeter zurueckSETZT. Ohne ihn loescht der Checkout dort nichts.
  //
  // Als Kommando und nicht automatisch, weil der Zeitpunkt alles entscheidet:
  // der Snapshot friert ein, worauf zurueckgesetzt wird. Die App nimmt ihn von
  // selbst nur auf einem Geraet ohne jede Spur eines Gastes; wer davor steht
  // und es besser weiss, schickt { force: true }.
  TAKE_CHECKOUT_SNAPSHOT: 'take_checkout_snapshot',
  // Alle Speicher des Geraets leeren. Verlangt confirm:true in der
  // Nutzlast - danach ist die Registrierung weg.
  CLEAR_STORAGE: 'clear_storage',
  CONFIGURE_SOFTAP: 'configure_softap',
  LAUNCH_APP: 'launch_app',
};

export default class SocketHandler {
  socket = null;

  constructor({ groupId, buildingId, deviceId }) {
    this.gid = store.state.device.groupId;
    this.url = `${process.env.SOCKET_BASE}/socket/client/${this.git}/${this.bid}/tv/${deviceId}`;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/SocketHandler.js